var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spl-export-proof-list-header"},[_c('form-button',{on:{"onClick":_vm.handleCreateExportProof}},[_vm._v(" Create Export Proof ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }